<!--<div class="col">
    <div class="row mt-4 mb-4">
        <div class="col">
            <uploader ref="firstAttachment"
                      :attachment-group-id="attachmentGroupId"
                      @file-was-selected="fileSelected"
                      @file-was-removed="fileRemoved">
                <template v-slot:add-attachment-row-content="props">
                        <div class="col">
                            <a href="#" @click.prevent="props.addattachment"><i class="fas fa-paperclip mr-2"></i>Add attachment(s) </a>
                        </div>
                    </template>
            </uploader>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <uploader :attachment-group-id="attachmentGroupId"
                      @file-was-selected="fileSelected"
                      @file-was-removed="fileRemoved"></uploader>
        </div>
    </div>
</div>-->
<!--bla: function () {
          this.$refs.firstAttachment.addAttachment();
           },-->
<!--selectedAttachments: [],-->
<!--fileSelected: function (t) {
                this.selectedAttachments.push(t);
            },

            fileRemoved: function (t) {
                this.selectedAttachments = this.selectedAttachments.filter(x => x.name != t.name);
            },
}-->

<template>

    <div>

        <div v-if="!selectedFile" class="row d-none">
            <div class="col">
                <input ref="fileUploadInput" :disabled="isUploading" type="file" class="custom-file-input" v-bind:class="{ 'is-invalid': clientSideErrorMessage }" :accept="acceptedTypes" @change="fileUploadControlStatusChange($event)">
            </div>
        </div>

        <div v-if="selectedFile" class="row">
            <div class="col">
                <div class="alert alert-warning alert-dismissible fade show bg-portal-primary-blue text-white mb-1" role="alert">
                    <div class="row">
                        <div class="col text-break">
                            <i class="far fa-file-alt mr-2" :aria-label="selectedFile.fileName"></i>
                            {{selectedFile.fileName}}
                        </div>
                        <div class="col-auto">
                            <span v-if="selectedFile.sizeInMb > 1">{{selectedFile.sizeInMb | toNumberTo2Decimals}} Mb</span>
                            <span v-else>{{selectedFile.sizeInKb | toNumberTo2Decimals}} Kb</span>
                        </div>

                        <button @click="deleteFile" type="button" class="close text-white delete-file-attachment" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
 
        <div v-if="isUploading" class="row">
            <div class="col">
                <div class="progress mt-2">
                    <div class="progress-bar progress-bar-striped" role="progressbar" :style="{ width: progressBarValue + '%' }" :aria-valuenow="progressBarValue" aria-valuemin="0" aria-valuemax="100">Uploading...{{progressBarValue}}%</div>
                </div>
            </div>
        </div>

        <div v-show="!selectedFile && !isUploading" class="row">
            <slot name="add-attachment-row-content" :addattachment="addAttachment"></slot>
            <div v-if="!hasAddAttachmentSlot" class="col">
                <a href="#" @click.prevent="addAttachment"><i class="fas fa-paperclip mr-2" aria-label="Add attachments"></i>{{ contentBlocks.addAttachments }}</a>
            </div>
        </div>

        <div v-if="clientSideErrorMessage" class="row">
            <div class="col text-danger">
                {{clientSideErrorMessage | firstError}}
            </div>
        </div>

    </div>

</template>

<style>
    .delete-file-attachment:hover {
        color: white !important;
    }
</style>

<script>

    import MessageEventBus from '@PortalEntryPoints/Messages/ComposeMessage/message.event.bus';
    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import { AjaxFileUploader } from '@SharedServices/ajax.file.uploader.service';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import { findFileExtension } from '@SharedServices/file.service';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';

    export default {
        name: 'fileUpload',
        props: {
            attachmentGroupId: { type: String },
            acceptedTypes: { type: String, default: '.doc,.docx,.bmp,.jpg,.jpeg,.xls,.xlsx,.png,.tif,.tiff,.txt,.pdf,.csv,image/*' }, //filter for the upload screen that defaults the filter to
            isTempUpload: { type: Boolean, default: false }, //is this a temporary upload ie: financial forms - upload then render to pdf and will never be sent in a psm
            prePopulateSelectedFile: { type: Object } //used mainly when you have a list and it rerenders and forgets what you did. ie: file.multiple.uploader
        },
        data: function () {
            return {
                selectedFile: this.prePopulateSelectedFile,

                progressBarValue: 0,
                clientSideErrorMessage: null,
                isUploading: false,
                isDeleting: false,
                contentBlocks: {}
            }
        },
        created: function(){
            MessageHttpSvc.GetContent()
                .done(res => {
                    this.contentBlocks = res;
                });
        },
        watch: {

            isUploading: function (newValue, oldValue) {
                this.$emit('is-doing-operation', newValue || this.isDeleting);
                MessageEventBus.$emit('IsUploading', newValue);
            },

            isDeleting: function (newValue, oldValue) {
                this.$emit('is-doing-operation', newValue || this.isUploading);
                MessageEventBus.$emit('IsUploading', newValue);
            }

        },
        computed: {
            supportedFileTypes: function () {
                if (!this.acceptedTypes) {
                    return {};
                }

                return this.acceptedTypes.split(',').Select(x => x.trim().toLowerCase()).ToHashSet();
            },

            hasAddAttachmentSlot() {
                return !!this.$scopedSlots['add-attachment-row-content'];
            }
        },
        methods: {

            addAttachment: function () {
                this.$refs.fileUploadInput.click();
            },

            deleteFile: function () {

                if (this.isDeleting) {
                    return;
                }

                this.isDeleting = true;

                MessageHttpSvc.DeletePsmAttachement(this.attachmentGroupId, this.selectedFile.fileName, this.isTempUpload)
                    .done(response => {
                        this.isDeleting = false;
                        this.$emit('file-was-removed', this.selectedFile, this.$vnode.key);
                        this.selectedFile = null;
                    });
            },

            fileUploadControlStatusChange: function (e) {

                //this is a callback for when the patient actually selects a file to be uploaded
                this.clientSideErrorMessage = null;

                let filesToUpload = e.target.files;

                if (!filesToUpload.length) {
                    return;
                }

                let fileToUpload = filesToUpload[0];

                let fileSizeInKb = fileToUpload.size / 1024;
                let fileSizeInMb = fileSizeInKb / 1024;
              
                if (!this.supportedFileTypes.ContainsItem(findFileExtension(fileToUpload.name).toLowerCase())) {
                    this.clientSideErrorMessage = ['File type not supported'];
                    return;
                }

                let reader = new FileReader();

                this.progressBarValue = 0;
                this.isUploading = true;
              
                //go stream the file to the psm service
                new AjaxFileUploader().UploadFile(fileToUpload, this.attachmentGroupId, this.isTempUpload)

                    .progress(progressResponse => {
                        this.progressBarValue = progressResponse;
                    })

                    .done(response => {

                        reader.onload = evt => {

                            let firstFile = response.files[0];

                            let selectedFileModel = {
                                fileName: firstFile.name,
                                sizeInMb: fileSizeInMb,
                                sizeInKb: fileSizeInKb,
                                urlBytes: reader.result
                            };

                            this.isUploading = false;
                            this.selectedFile = selectedFileModel
                            this.$emit('file-was-selected', selectedFileModel, this.$vnode.key);
                            this.progressBarValue = 100;
                        }

                        reader.readAsDataURL(fileToUpload);
                    }).fail(errResponse => {
                        this.progressBarValue = 0;
                        this.isUploading = false;
                        this.isDeleting = false;

                        this.$emit('is-doing-operation', false);
                        MessageEventBus.$emit('IsUploading', false);
                        this.clientSideErrorMessage = ['An error has occurred uploading the file. If you need help immediately, please contact the MyMSK Help Desk at 646-227-2593 Monday through Friday from 9 a.m. to 5 p.m.(Eastern time).'];
                    });
            }

        },
        destroyed: function () {
            //here because in file.multiple.uploader we kill the component and re-render. so we always want to say its done to renable the buttons
            this.$emit('is-doing-operation', false);
            MessageEventBus.$emit('IsUploading', false);
        }
    };
</script>

